import { Card, Icon, Tooltip } from "pepsico-ds";
import { useEffect } from "react";
import { useMatch, useParams, useSearchParams } from "react-router-dom";
import React from "react";
import { set } from "zod";
interface ChatItemProps {
  session_name: string;
  onChatClick?: () => void;
  sessionId: string;
  questionId: string;
  activeQuestionId: string;
  index: number;
}

const ChatQuestion: React.FC<ChatItemProps> = ({
  session_name,
  onChatClick,
  sessionId,
  questionId,
  activeQuestionId,
  index,
}) => {
  const chatPath = useMatch("/spend-wise-hub/chat-assistant/:sessionId");
  const newChatPath = useMatch("/spend-wise-hub/chat-assistant");
  const [searchParams] = useSearchParams();
  const params = useParams<{ sessionId: string }>();
  const { sessionId: urlSession } = params;

  const isActiveonBase =
    urlSession === sessionId &&
    searchParams.get("questionId") === null &&
    index === 0
      ? true
      : false;

  const isActiveOnQuestion =
    urlSession === sessionId && searchParams.get("questionId") === questionId;
  const isActive = isActiveOnQuestion || isActiveonBase;

  const maxLength = 25;
  const truncatedSessionName =
    session_name.length > maxLength
      ? session_name.slice(0, maxLength) + "..."
      : session_name;

  return (
    <div
      onClick={onChatClick}
      className={`chatItem ${isActive ? "active" : ""}`}
    >
      <Card
        ellipsis={false}
        style={{
          padding: "8px 8px 8px 0px",
          display: "flex",
        }}
      >
        <Icon
          alt="chat-icon"
          className="$color-icon-default"
          icon="chat"
          size="small"
          onClick={onChatClick}
          style={{ margin: "0px 8px 0px 12px" }}
        />
        <Tooltip
          direction="bottom-middle"
          text={session_name}
          maxWidth="170px"
          style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
        >
          <div className="$font-body-small">
            {truncatedSessionName.charAt(0).toUpperCase() +
              truncatedSessionName.slice(1)}
          </div>
        </Tooltip>
      </Card>
    </div>
  );
};

export default ChatQuestion;
